require('./brokerCustomWalletPortfolio.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ utils
const { formatText, FormattedText } = require('core/i18n').i18n;
const classNames = require('classnames');
// @ helpers
const { getFirstNChars } = require('utilities/stringHelper');
//@ constants
const { BROKER_CUSTOM_CONFIG_WALLET_NAME_LIMIT, BROKER_CUSTOM_WALLET_CREATE_ACCOUNT_ID } = require('../../constants/index');

class BrokerCustomWalletPortfolioSubtitle extends React.Component {

    constructor(props) {
        super(props);
    }

    getSubtitleContractName() {
        const { immPortfolio } = this.props;
        const count = immPortfolio.get('count');
        let subtitle = formatText('brokerCustomWallet-noContractsInfoSubtitle');

        if (count) {
            if (count == 1) {
                subtitle = '1 ' + formatText('brokerCustomWallet-oneVisibleContractSubtitle');
            } else if (count == 0) {
                subtitle = '0 ' + formatText('brokerCustomWallet-ceroVisibleContractsSubtitle');
            } else if (immPortfolio.get('idPortfolioAccount') === BROKER_CUSTOM_WALLET_CREATE_ACCOUNT_ID) {
                subtitle = <FormattedText value="brokerCustomWallet-allVisibleContractsSubtitle" injectedStrings={[count]} />
            } else if (count > 1) {
                subtitle = <FormattedText value="brokerCustomWallet-someVisibleContractsSubtitle" injectedStrings={[count]} />
            }
        }

        return (
            <span className="custom-wallet-portfolio__name__contracts">
                {subtitle}
            </span>
        );
    }

    buildContractName() {
        const { immPortfolio, isDefaultView } = this.props;
        const descriptionPortfolioAccount = immPortfolio.get('descriptionPortfolioAccount');
        const defaultSubtitleContractName = this.getSubtitleContractName();
        const portfolioClassName = classNames('custom-wallet-portfolio__name', {
            'custom-wallet-portfolio__name__default': isDefaultView
        });

        return (
            <div className={portfolioClassName}>
                <span className="custom-wallet-portfolio__name__portfolio">
                    {getFirstNChars(descriptionPortfolioAccount, BROKER_CUSTOM_CONFIG_WALLET_NAME_LIMIT)}
                </span>
                {defaultSubtitleContractName}
            </div>
        );
    }

    render() {
        return (
            this.buildContractName()
        );
    }
}

BrokerCustomWalletPortfolioSubtitle.propTypes = {
    immPortfolio: PropTypes.any.isRequired,
    totalContractsCount: PropTypes.number,
    totalAlreadyMerged: PropTypes.bool,
    isDefaultView: PropTypes.bool
};

module.exports = BrokerCustomWalletPortfolioSubtitle;
